import AvatarMini from "components/commons/AvatarMini"
import { Dialog } from "primereact/dialog"
import { Knob } from "primereact/knob"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDeleteDeviceMutation } from "../api/devicesStatusApiSlice"
import { relativeTime } from "utility/TimeUtility"


export default function DeviceCard({
    device,
    canManageDevices = false,
    handleAction = (_deviceGuid, _action) => { },
    handleChangeStatus = (_e, _deviceGuid) => { }
}) {

    const MAX_DATA_AGE_SECONDS = 60 * 60 * 24; // 24 ore
    const [t] = useTranslation(["global", "device"])

    function DeviceStatusBadge({ device }) {
        let color
        let textColor = "white"
        switch (device.smartStatus) {
            case "CHARGING": color = "bg-primary"
                break
            case "OFFBODY": color = "bg-warning"; textColor = "dark"
                break
            case "IN_USE": color = "bg-success"
                break
            case "DISABLED": color = "bg-danger"
                break
            default: color = "dark"
        }
        return <span className={`badge rounded-pill ${color} text-${textColor}`} style={{ opacity: calculateAlpha() }}>
            {device.status.isCharging && <i className="fa-solid fa-bolt"></i>}{" "}
            {t(`device:entity.device.smart_status.${device.smartStatus}`).toUpperCase()}
        </span>
    }

    function getDeviceTypeIcon() {
        let icon
        switch (device.type) {
            case "WATCH": icon = <i className="fa-solid fa-clock"></i>
                break
            case "DEVICE": icon = <i className="fa-solid fa-tablet-screen-button"></i>
                break
            default: icon = ""
        }
        return icon
    }

    // Funzione per determinare la classe colore per l'icona della batteria
    const getBatteryClass = (device) => {
        if (device.status.isCharging)
            return "#0d6efd" // blu
        if (device.status.batteryLevel < 15) return "#cd3342"; // rosso
        if (device.status.batteryLevel < 25) return "orange";  // arancio
        if (device.status.batteryLevel < 50) return "#ffc107";  // giallo
        return "#198754";                         // verde
    };

    function calculateAlpha(
        nowSeconds = Math.floor(Date.now() / 1000)
    ) {
        const age = Math.max(0, nowSeconds - device.lastUpdate);

        return age >= MAX_DATA_AGE_SECONDS
            ? 0
            : 1 - age / MAX_DATA_AGE_SECONDS;
    }


    return <tr className="">
        <td className="text-muted">{device.guid.substr(device.guid.length - 5)}</td>
        <td>
            <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" disabled={!canManageDevices} checked={device.enabled} onChange={(e) => { handleChangeStatus(e, device.guid) }} />
            </div>
        </td>
        <td><small className="text-muted">{device.ip}</small></td>
        <td>
            <div className="d-flex align-items-center gap-2">
                {getDeviceTypeIcon()}{device.model}
            </div>
            <small className="text-muted">{device.version}</small>
        </td>

        <td>
            {device.status?.batteryLevel != null &&
                <Knob
                    value={device.status.batteryLevel}
                    valueTemplate={`${device.status.batteryLevel}`}
                    valueColor={getBatteryClass(device)}
                    strokeWidth={8}
                    size={72}
                    style={{ opacity: calculateAlpha() }}
                />
            }
        </td>
        <td>
            <DeviceStatusBadge device={device} />
        </td>
        <td>
            <div className="text-muted">
                {relativeTime(device.lastUpdate)}
            </div>
        </td>
        <td>
            {
                device.lastUser &&
                <AvatarMini displayName={device.lastUser.displayName} guid={device.lastUser.guid} abbreviate={true} />
            }
        </td>
        <td>
            {
                device.status.isLogged == true ?
                    <div className="btn-group">
                        <button className="btn btn-primary" onClick={() => { handleAction(device.guid, "UPDATE_STATUS") }}><i className="fa-solid fa-retweet"></i> Refresh</button>

                        <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                            <span className="visually-hidden">Toggle Dropdown</span>
                        </button>
                        <ul className="dropdown-menu">
                            <li> <button className="dropdown-item" onClick={() => { handleAction(device.guid, "IDENTIFY") }}><i className="fa-solid fa-eye" ></i> Identifica</button></li>
                            <li> <button className="dropdown-item" onClick={() => { handleAction(device.guid, "ASK_FOR_RETURN") }}><i className="fa-solid fa-house-flag"></i> Chiedi il ritorno</button></li>
                            {
                                canManageDevices &&
                                <>
                                    <li> <button className="dropdown-item" onClick={() => { handleAction(device.guid, "LOGOUT") }}><i className="fa-solid fa-right-from-bracket"></i> Disconnetti</button></li>
                                    <li><DeleteDeviceTemplate device={device} btnClassName="dropdown-item text-danger" /></li>
                                </>
                            }
                        </ul>
                    </div> : canManageDevices && <DeleteDeviceTemplate device={device} btnClassName="btn btn-danger text-white" />}
        </td>
    </tr>
}


const DeleteDeviceTemplate = ({ device, btnClassName = "btn btn-danger" }) => {
    const [t] = useTranslation(["global", "device"]);
    const [openDialog, setOpenDialog] = useState(false);
    const [deleteDevice] = useDeleteDeviceMutation()
    return (
        <>
            <button className={btnClassName} onClick={() => setOpenDialog(true)}><i className="fa-solid fa-trash"></i> {t("action.delete")}</button>
            <Dialog header={t("device:actions.delete_device")} visible={openDialog} onHide={() => setOpenDialog(false)} >
                <span>{t("device:helper.device_delete_confirm")} <b>{device.guid.substr(device.guid.length - 5)}</b> ?</span>
                <div className="text-end mt-4">
                    <button className="btn btn-danger mx-2" onClick={() => {
                        deleteDevice(device.guid)
                        setOpenDialog(false)
                    }}>  {t("action.delete")} </button>
                    <button className="btn btn-secondary" onClick={() => setOpenDialog(false)}>{t("action.cancel")}</button>
                </div>
            </Dialog>
        </>
    );
};